<template>
  <form class="form-horizontal" v-if="campaign">
    <div class="row">
      <div class="form-group col-md-6">
        <CampaignName :campaign="campaign" />
      </div>
      <div class="form-group col-md-3">
        <StatusDropdown :campaign="campaign" @updated="$emit('updated')" />
      </div>
    </div>
    <hr />

    <div class="row">
      <CampaignDuration :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <BackgroundImage :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <HeadLineImage :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <TextArea :campaign="campaign" />
    </div>
    <hr />
    <div class="row">
      <ProgressbarPicture :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <TargetAndReward :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <TargetSKU :campaign="campaign" />
    </div>
    <hr />
    <div class="row">
      <TeamTargetAndRewardValues :campaign="campaign" @updated="$emit('updated')" />
      <UserTeamAssignment :campaign="campaign" @updated="$emit('updated')" />
    </div>
  </form>
</template>

<script>
import TextArea from "./components/TextArea.vue";
import TargetSKU from "./components/TargetSKU.vue";
import HeadLineImage from "./components/HeadLineImage.vue";
import StatusDropdown from "./components/StatusDropdown.vue";
import TargetAndReward from "./components/TargetAndReward.vue";
import BackgroundImage from "./components/BackgroundImage.vue";
import CampaignDuration from "./components/CampaignDuration.vue";
import ProgressbarPicture from "./components/ProgressbarPicture.vue";
import UserTeamAssignment from "./components/UserTeamAssignment.vue";
import CampaignName from "@/views/progressbar/components/CampaignName.vue";
import TeamTargetAndRewardValues from "./components/TeamTargetAndRewardValues.vue";

export default {
  name: "TeamForm",

  props: ["campaign"],

  components: {
    TextArea,
    TargetSKU,
    CampaignName,
    HeadLineImage,
    StatusDropdown,
    TargetAndReward,
    BackgroundImage,
    CampaignDuration,
    ProgressbarPicture,
    UserTeamAssignment,
    TeamTargetAndRewardValues,
  },
};
</script>
